export const siteLogo = {
    logo: "assets/images/jute_foster_logo.png",  // Add your site logo here
    alt: "Jute Foster"  // Add your site name here
};
export const socialLink = {
    facebook: "https://www.facebook.com",
    twitter: "https://www.twitter.com",
    linkedin: "https://www.linkedin.com",
    youtube: "https://www.youtube.com",
    whatsapp: "https://www.whatsapp.com",
};
export const mailchimpLink = {
    link: (process.env.REACT_APP_MAILCHAIMP) // Add your mailchimp list link here
};
export const contactFormAction = {
    link: (process.env.REACT_APP_CONTACTFORM)  // Add for link here from https://formspree.io
}
export const contactMap = {
    link: (process.env.REACT_APP_CONTACTMAP) // Add google map link from here: https://www.embedgooglemap.net/
}
